var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoSmtp24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "server",
    transform: "translate(0 -19.968)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25016",
    "data-name": "Group 25016",
    transform: "translate(0 19.968)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25015",
    "data-name": "Group 25015"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46080",
    "data-name": "Path 46080",
    d: "M15.519,19.968H2.481a2.407,2.407,0,1,0,0,4.811H15.519a2.407,2.407,0,1,0,0-4.811ZM3.981,23.045a.679.679,0,0,1-.692-.671.651.651,0,0,1,.673-.671.709.709,0,0,1,.712.671A.679.679,0,0,1,3.981,23.045Zm2.269,0a.679.679,0,0,1-.692-.671.651.651,0,0,1,.673-.671.709.709,0,0,1,.712.671A.679.679,0,0,1,6.25,23.045Zm2.25,0a.672.672,0,1,1,.692-.671A.679.679,0,0,1,8.5,23.045Z",
    transform: "translate(0 -19.968)",
    fill: "#999"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25018",
    "data-name": "Group 25018",
    transform: "translate(0 25.562)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25017",
    "data-name": "Group 25017"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46081",
    "data-name": "Path 46081",
    d: "M15.519,173.568H2.481a2.407,2.407,0,1,0,0,4.811H15.519a2.407,2.407,0,1,0,0-4.811ZM3.981,176.645a.679.679,0,0,1-.692-.671.707.707,0,0,1,.692-.69.7.7,0,0,1,.712.671A.712.712,0,0,1,3.981,176.645Zm2.25,0a.679.679,0,0,1-.692-.671.707.707,0,0,1,.692-.69.7.7,0,0,1,.712.671A.712.712,0,0,1,6.231,176.645Zm2.269,0a.672.672,0,1,1,.692-.671A.679.679,0,0,1,8.5,176.645Z",
    transform: "translate(0 -173.568)",
    fill: "#999"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25020",
    "data-name": "Group 25020",
    transform: "translate(0 31.157)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25019",
    "data-name": "Group 25019"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46082",
    "data-name": "Path 46082",
    d: "M15.519,327.168H2.481a2.407,2.407,0,1,0,0,4.811H15.519a2.407,2.407,0,1,0,0-4.811ZM3.981,330.245a.679.679,0,0,1-.692-.671.707.707,0,0,1,.692-.69.7.7,0,0,1,.712.671A.712.712,0,0,1,3.981,330.245Zm2.25,0a.679.679,0,0,1-.692-.671.707.707,0,0,1,.692-.69.7.7,0,0,1,.712.671A.712.712,0,0,1,6.231,330.245Zm2.269,0a.672.672,0,1,1,.692-.671A.679.679,0,0,1,8.5,330.245Z",
    transform: "translate(0 -327.168)",
    fill: "#999"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoSmtp24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_smtp24x24.c19f39c5b5ea8eb64a4d6f07ac727910.svg";